"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.TrStatusReducer = undefined;

var _translate = require("@esnpm/translate");

var _apiTrStatusTranslation = require("../actions/esdb/apiTrStatusTranslation");

var TrStatusReducer = exports.TrStatusReducer = function TrStatusReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        loading: false,
        data: null,
        error: null
    };
    var action = arguments[1];

    switch (action.type) {
        case _apiTrStatusTranslation.API_TR_STATUS_TRANSLATION_SUCCESS:
            if (action.payload.data == null || action.payload.data == {}) {
                return state;
            }
            var newState = (0, _translate.registerTranslation)(state, "trStatus", action.payload.data);
            return newState;

        default:
            return state;
    }
};